import React, { useContext, useEffect, useMemo, useState } from "react";
import locationContext from "../../../app/providers/location/locationContext";
import { Box, Grid } from "@mui/material";
import '../../../shared/styles/style.css';
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import filterContext from "../../../app/providers/filter/filterContext";
import orderByContext from "../../../app/providers/orderBy/orderByContext";
import carBrandContext from "../../../app/providers/car-brands/carBrandContext";
import WorkshopListSkeleton from "./laoding_components/WorkshopCardSkeleton";
import WorkshopListTopBar from "./WorkshopListTopBar";
import Marketing1 from "../../../shared/components/Marketing1";
import CountAndOrderBy from "./CountAndOrderBy";
import EmptySearch from "./workshop_extras/EmptySearch";
import Map from "../../../shared/components/Map";
import BottomDrawer from "../../../shared/components/BottomDrawer";
import { useDispatch, useSelector } from "react-redux";
import { defaultLocation, emptyWorkshopForMap } from "../../../app/store/workshopSlice";
import { useGetWorkshopsQuery } from "../../../app/store/api/workshopApi";
import WorkshopListCard from "./WorkshopListCard";
import { useTranslation } from "react-i18next";
import { clearDraftDate } from "../../../app/store/reservationSlice";
import sortWorkshopsByOrder from "../utils/sortWorkshopsByOrder";

export default function Workshops() {
    const {t} = useTranslation()
    const { state: locationState } = useContext(locationContext);
    const { state: filterState } = useContext(filterContext);
    const { state: orderByState } = useContext(orderByContext);
    const { state: carBrandState } = useContext(carBrandContext);
    const storedDefaultLocation = useSelector(defaultLocation);
    const draftCar = useSelector((state) => state.reservation.draft.car);
    const location = locationState.location || storedDefaultLocation;
    const filter = filterState.filter || [];
    const selectedCar = draftCar || carBrandState.brand;
    const {data:workshopsList,isLoading:loading} = useGetWorkshopsQuery({ location, filter, car: selectedCar });
    const [open, setOpen] = useState(false);
    const { isDesktop } = useWindowSize();
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(emptyWorkshopForMap())
        dispatch(clearDraftDate())
    },[dispatch])

    const sortedWorkshopsList = useMemo(() => {
        return sortWorkshopsByOrder(workshopsList, orderByState.orderBy);
    }, [workshopsList, orderByState.orderBy]);

    const workshopCardsList = (
        <Grid container spacing={1}>
            { loading ?
                [...Array(5)].map((_, index) => (
                    <WorkshopListSkeleton key={index} />
                ))
                :
                sortedWorkshopsList && sortedWorkshopsList?.map((workshop, index) => (
                    <WorkshopListCard key={index} workshop={workshop} />
                ))               
            }
        </Grid>
    );

    return (
        <Box
            className="workshops-grid"
            sx={
                isDesktop
                    ? {
                        maxHeight: "calc(100vh - 64px)",
                        overflowY: "auto",
                    }
                    : {}
            }
        >
            {/* { filterState?.filter && <Filter /> } */}
            {/* { filterState?.filter && <FiltersSelected /> } */}
            <WorkshopListTopBar />
            <CountAndOrderBy />
            <>
                <Box sx={{ marginTop: '16px' }}>
                    {workshopCardsList}
                </Box>
                { workshopsList?.length === 0 && <EmptySearch /> }
                { !isDesktop && <BottomDrawer
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    title={t("workshop.showOnMap")}
                    height="90vh"
                >
                    <Map />
                </BottomDrawer>}
                <Box sx={{ marginTop: '16px', borderRadius: '8px', overflow: 'hidden' }}>
                    <Marketing1 />
                </Box>
            </>
        </Box>
    );
}